import React, { HTMLAttributes, HTMLProps } from 'react';
import Immutable from 'immutable';
import { useTranslation } from 'react-i18next';

import {
  Paragraph,
} from '@uncinc/react-drupal-core';

import {
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import { ImmutableGenericNodeEntity } from '../..';
import { CoreLink, Feedback } from '../../../../components';
import useClasses from '../../../../hooks/useClasses';
import useRoutes from '../../../../hooks/useRoutes';

import './style.scss';

interface Props extends HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableGenericNodeEntity;
}

const NodeTipFull: React.FC<Props> = ({ entity, className }) => {
  const { t } = useTranslation();
  const { help } = useRoutes();
  const { buildClass, joinClasses } = useClasses('NodeTipFull');

  const title = entity.getIn(['title', 0, 'value'], '');
  const body = entity.getIn(['body', 0, 'processed'], '');
  const paragraphs = entity.get('field_paragraphs', Immutable.List());
  const isUpvoted = (entity.getIn(['flags', 'upvote_tip'], Immutable.List()) as Immutable.List<unknown>).size > 0;
  const isDownvoted = (entity.getIn(['flags', 'downvote_tip'], Immutable.List()) as Immutable.List<unknown>).size > 0;

  return (
    <div className="col-lg-7 py-8 py-lg-12">
      <article className={joinClasses(buildClass(), className)}>
        <header className={buildClass('header')}>
          <CoreLink
            to={help}
            title={t('buttons.back')}
            className="icon-before icon-chevron icon-orientation-left"
          />
        </header>

        <div className={buildClass('title')}>
          <h1>{title}</h1>
        </div>

        {body.length > 0 && (
          <div className={buildClass('body')}>
            <WysiwygField
              property="schema:text"
              html={body}
            />
          </div>
        )}

        {paragraphs.size > 0 && (
          <ul className={buildClass('paragraphs')}>
            {paragraphs.map((paragraph) => {
              const id = paragraph.get('target_id');

              return (
                <li key={`paragraph:${id}`}>
                  <Paragraph
                    id={id}
                    entity={paragraph.get('entity')}
                    isWide
                  />
                </li>
              );
            })}
          </ul>
        )}
      </article>

      <Feedback
        parentEntityId={entity.getIn(['nid', 0, 'value'])}
        parentEntityType="node"
        upvote={isUpvoted}
        downvote={isDownvoted}
      />
    </div>
  );
};

export default NodeTipFull;
